/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useContext } from 'react';
import { FormGroup, Button, Alert } from 'react-bootstrap';
import { Context } from 'context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { appConst } from 'constants/appConstants';
import { UPDATE_SENHA } from 'services/Usuario';
import './styles.scss';
import PasswordValidation from 'components/PasswordValidation';
import showToast from 'utils/toast';

const FormPassword = () => {
  const userAuth = JSON.parse(localStorage.getItem(appConst.STORAGE_NAME));
  const [alterarSenha, setAlterarSenha] = useState({
    usuarioId: userAuth?.userId || 0,
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const { showLoader } = useContext(Context);

  const onSubmit = async () => {
    showLoader(true);
    setErrorMessage('');
    setShowSuccess(false);

    if (alterarSenha.novaSenha !== alterarSenha.confirmacaoSenha) {
      showToast.error('O campo confirmação senha deve ser igual a nova senha.');
      setErrorMessage('O campo confirmação senha deve ser igual a nova senha.');
      showLoader(false);
      return false;
    }

    try {
      const requestBody = {
        usuarioId: alterarSenha.usuarioId,
        senhaAtual: alterarSenha.senhaAtual,
        novaSenha: alterarSenha.novaSenha,
        confirmacaoSenha: alterarSenha.confirmacaoSenha,
      };

      const data = await UPDATE_SENHA(requestBody);

      if (data.value === false && data.errors && data.errors.length > 0) {
        setErrorMessage(data.errors[0]);
      } else if (data.value === true) {
        setShowSuccess(true);
        localStorage.removeItem(appConst.STORAGE_NAME);
        localStorage.removeItem(appConst.TOKEN_NAME);
        // Aguarda um pouco para mostrar a mensagem de sucesso
        setTimeout(() => {
          window.location.replace('/login');
        }, 1000);
      } else {
        setErrorMessage('Não foi possível executar esta operação!');
      }
    } catch (error) {
      if (error.response?.status === 400) {
        const errorDetails =
          error.response?.data?.errors ||
          error.response?.data?.detail ||
          error.response?.data?.title;
        if (errorDetails) {
          if (
            typeof errorDetails === 'object' &&
            !Array.isArray(errorDetails)
          ) {
            const errorList = Object.keys(errorDetails)
              .map(
                (key) =>
                  `${key}: ${
                    Array.isArray(errorDetails[key])
                      ? errorDetails[key].join(', ')
                      : errorDetails[key]
                  }`
              )
              .join('; ');
            setErrorMessage(errorList);
          } else if (Array.isArray(errorDetails)) {
            setErrorMessage(errorDetails.join('; '));
          } else {
            setErrorMessage(errorDetails);
          }
        } else {
          setErrorMessage(
            'Erro ao atualizar senha. Verifique os dados e tente novamente.'
          );
        }
      } else {
        setErrorMessage(
          error.response?.data?.message ||
            error.message ||
            'Erro ao atualizar senha. Tente novamente.'
        );
      }
    }

    document.getElementById('senhaAtual').value = '';
    document.getElementById('novaSenha').value = '';
    document.getElementById('confirmacaoSenha').value = '';

    showLoader(false);
    return false;
  };

  function onChangeInput(event) {
    const { value, name } = event.target;

    setAlterarSenha({
      ...alterarSenha,
      [name]: value,
    });
  }

  return (
    <div>
      <div className="title">ALTERAR SENHA</div>
      <div className="info">
        <form className="formPassword">
          {errorMessage && (
            <Alert
              variant="danger"
              onClose={() => setErrorMessage('')}
              dismissible
            >
              {errorMessage}
            </Alert>
          )}
          {showSuccess && (
            <Alert
              variant="success"
              onClose={() => setShowSuccess(false)}
              dismissible
            >
              Senha alterada com sucesso!
            </Alert>
          )}
          <FormGroup className="row">
            <label className="col-md-4 col-form-label text-md-right">
              Senha Antiga
            </label>
            <div className="col-md-6">
              <input
                type="password"
                id="senhaAtual"
                name="senhaAtual"
                onChange={onChangeInput}
                className="form-control"
              />
            </div>
          </FormGroup>
          <FormGroup className="row">
            <label className="col-md-4 col-form-label text-md-right">
              Nova Senha
            </label>
            <div className="col-md-6">
              <input
                type="password"
                id="novaSenha"
                name="novaSenha"
                onChange={onChangeInput}
                className="form-control"
              />
            </div>
          </FormGroup>
          <FormGroup className="row">
            <label className="col-md-4 col-form-label text-md-right">
              Confirmar Senha
            </label>
            <div className="col-md-6">
              <input
                type="password"
                id="confirmacaoSenha"
                name="confirmacaoSenha"
                onChange={onChangeInput}
                className="form-control"
              />
            </div>
          </FormGroup>
          <FormGroup className="row">
            <div className="offset-md-4 col-md-4">
              <PasswordValidation
                password={alterarSenha.novaSenha || ''}
                confirmPassword={alterarSenha.confirmacaoSenha || ''}
              />
            </div>
          </FormGroup>

          <FormGroup className="row">
            <div className="offset-md-4 col-md-4">
              <Button
                onClick={onSubmit}
                className="query-button"
                variant="primary"
              >
                <FontAwesomeIcon icon={faSave} /> Salvar
              </Button>
            </div>
          </FormGroup>
        </form>
      </div>
    </div>
  );
};

export default FormPassword;
